enum CountdownDisplayIndex {
    WHITELIST_MINT,
    PRE_MINT,
    PUBLIC_MINT
}

export default CountdownDisplayIndex;